import React, { memo } from "react";

import PwaInstallationDialog from "./PwaInstallationDialog";
import { FunctionWithVoidReturn } from "../../utils/constants/generic-types";
import { EnableNotificationsSteps } from "../../hooks/useNotifications";

interface NotificationFlowProps {
  handleNotifyMe: () => Promise<void>;
  handleGetApp?: FunctionWithVoidReturn;
  enableNotificationsStep: EnableNotificationsSteps;
  isEnableNotificationsDialogOpen: boolean;
  isPwaInstallationDialogOpen: boolean;
  openEnableNotificationsDialog: () => void;
  closePwaInstallationDialog: () => void;
  closeEnableNotificationsDialog: () => void;
}

function NotificationFlow({
  isPwaInstallationDialogOpen,
  closePwaInstallationDialog,
}: NotificationFlowProps) {
  return (
    <>
      <PwaInstallationDialog
        isOpen={isPwaInstallationDialogOpen}
        onClose={closePwaInstallationDialog}
      />
    </>
  );
}

export default memo(NotificationFlow);
